var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 34",
    style: {
      enableBackground: "new 0 0 26 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 24,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0v34h26V0H0z M23,31H3V3h20V31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRead);
export default __webpack_public_path__ + "static/media/ic_read.2f2af1f10a5284b39a73696162b2a792.svg";
export { ForwardRef as ReactComponent };